export default "__VITE_ASSET__DM9V58G9__"